<div class="condicoes" ngxUiLoaderBlurred [loaderId]="'loader-principal'">
    <app-header
        [brandIconName]="pedido?.marca"
        [title]="pedido?.veiculo"
        [subtitle]="('buyer.condicoes.seguradora' | translate) + ': ' + pedido?.seguradora"
        (onGoBack)="voltar(null)"
    ></app-header>

    <div class="row condicoes-wrapper">
        <div class="col-md-6 card card-default painelcomprador area-respostas {{ accountService.getCssInIframe() }}">
            <div class="card-header mb10">
                {{ 'buyer.condicoes.nao-compradas.titulo' | translate}}
            </div>
            <ng-scrollbar>
                @if (respostas_nao_compradas.length > 0) {
                    <app-lista-respostas [respostas]="respostas_nao_compradas" (selecionarPeca)="selecionarPeca($event)"></app-lista-respostas>
                } @else {
                    <div class="card-body text-center">
                        {{ 'buyer.condicoes.nao-compradas.vazio' | translate}}
                    </div>
                }

                <div ngbAccordion accordion="NgbAccordion" class="ngbAccordion" >
                    @if (respostas_nao_respondida?.length > 0) {
                        <div ngbAccordionItem="panelNaoRespondidas">
                            <div ngbAccordionHeader>
                                <button ngbAccordionButton>
                                    {{'buyer.condicoes.nao-compradas.nao-respondido' | translate}}
                                </button>
                            </div>
                            <div ngbAccordionCollapse>
                                <section ngbAccordionBody class="d-flex flex-wrap striped bordered card-body">
                                    <ng-template>
                                        <section class="corpo">
                                            @for (resposta of respostas_nao_respondida; track resposta) {
                                                <div class="linha cursor-pointer">
                                                    <div class="col-0-5">{{resposta.vendedor}}</div>
                                                    <div class="col-0-5">{{resposta.phone}}</div>
                                                </div>
                                            }
                                        </section>
                                    </ng-template>
                                </section>
                            </div>
                        </div>
                    }
                    @if (respostas_nao_participando?.length > 0) {
                        <div ngbAccordionItem="panelNaoParticipando">
                            <div ngbAccordionHeader>
                                <button ngbAccordionButton>
                                    {{'buyer.condicoes.nao-compradas.nao-participando' | translate}}
                                </button>
                            </div>
                            <div ngbAccordionCollapse>
                                <section ngbAccordionBody class="d-flex flex-wrap striped bordered card-body">
                                    <ng-template>
                                        <section class="corpo">
                                            @for (resposta of respostas_nao_participando; track resposta) {
                                                <div class="linha cursor-pointer">
                                                    <div class="col-0-5">{{resposta.vendedor}}</div>
                                                    <div class="col-0-5">{{resposta.phone}}</div>
                                                </div>
                                            }
                                        </section>
                                    </ng-template>
                                </section>
                            </div>
                        </div>
                    }
                </div>
            </ng-scrollbar>
        </div>

        <div class="col-md-6 painelcomprador area-comprar {{ accountService.getCssInIframe() }}">
            <div class="card card-default">
                <div class="card-header mb10">
                    {{ 'buyer.condicoes.compradas.titulo' | translate}}
                </div>
                <div class="area-comprar-visao-geral-scroll {{ accountService.getCssInIframe() }}">
                    <ng-scrollbar>
                        <app-lista-respostas [respostas]="respostas_compradas" (selecionarPeca)="selecionarPeca($event)"></app-lista-respostas>
                    </ng-scrollbar>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>
